export default {
  general: {
    tip: 'Tip',
    hello: 'Hallo',
    back: 'Terug',
    left: 'Links',
    right: 'Rechts',
    both: 'Beide',
    side: 'Zijkant',
    flank: 'Zijde',
    backside: 'Achterkant',
    height: 'Hoogte',
    depth: 'Diepstand',
    thickness: 'Dikte',
    standard: 'Standaard',
    kind: 'Soort',
    position: 'Positie',
    fixation: 'Bevestiging',
    material: 'Materiaal',
    extension: 'Verlenging',
    explanation: 'Toelichting',
    material_type: 'Materiaal type',
    including_supplement: 'Inclusief supplement',
    clothe: 'Bekleden',
    type: 'Type',
    model: 'Model',
    search: 'Zoeken',
    cancel: 'Annuleren',
    send: 'Versturen',
    ok: 'Oke',
    continue_anyway: 'Toch doorgaan',
    categorie: 'Categorie',
    update: 'Er is een update beschikbaar.',
    install_update: 'Nu updaten',
    user: 'Gebruiker',
    products: 'Producten',
    client_info: 'Klantgegevens',
    agreed_terms: 'Hierbij accepteer ik het {0} en de {1}',
    privacy_policy: 'privacybeleid',
    processing_agreement: 'verwerkingsovereenkomst',
    order: 'Bestellen',
    edit: 'Wijzigen',
    coming_soon: 'Binnenkort beschikbaar',
    add_file: 'Bestand toevoegen',
    salutation_mr: 'Dhr.',
    salutation_mrs: 'Mw.',
    terms: 'Algemene- en productvoorwaarden',
    not_available: 'Tijdelijk niet leverbaar',
    updated_color: 'Kleur is aangepast',
    manual: 'Materiaalboek',
  },
  alert: {
    text: 'Vanwege onderhoud van 31 oktober 18:00 uur tot 03 november 12:00 uur buiten gebruik',
  },
  error: {
    header_api: 'Er is een API fout opgetreden',
  },
  account: {
    customer_portal: 'Klantportaal',
    title: 'Account',
    login: 'Inloggen',
    signout: 'Uitloggen',
    username: 'Gebruikersnaam',
    password: 'Wachtwoord',
    forgotpassword: 'Wachtwoord vergeten',
    logged_in: 'Je bent ingelogd',
    error: {
      title: 'Onjuiste login gegevens',
      not_found: 'Ongeldige gebruikersnaam/wachtwoord combinatie',
    },
  },
  orders: {
    title: 'Order menu',
    synchronise: 'Synchroniseer orders',
    history: 'Order historie',
    archive: 'Gearchiveerde orders',
    custom: 'Custom',
    history_compatibility_header: 'Order niet compatibel',
    history_compatibility_message: 'Let op: deze order is niet compatibel met deze app versie. Controleer of de order correct is.',
    no_results: 'geen orders gevonden',
  },
  language: {
    title: 'Taal wijzigen',
    dutch: 'Nederlands',
    german: 'Deutsch',
    english: 'English',
    french: 'Français',
  },
  form: {
    choose_option: 'Kies optie',
    not_available: 'Geen',
    input_placeholder: 'Typen...',
    type: 'Type',
    number: 'Nummer',
    errors_heading: 'Formulier is niet volledig',
    errors_text: 'Er zijn een aantal velden niet volledig ingevoerd.',
    success_heading: 'Formulier is geldig',
    success_text: 'Formulier is klaar om te versturen.',
    save: 'Opslaan',
    select_ok: 'OK',
    select_cancel: 'Annuleren',
    undeliverable: '{field} is niet leverbaar',
    tvo_height_too_high: 'TVO-hoogte is te hoog.',
    tvo_height_too_high_full: 'De TVO-hoogte overschrijdt de gekozen schachthoogte in combinatie met de gekozen Uitvoering boord.',
  },
  flea: {
    liner_note: 'De voorbladvoeringen en hielpand voering worden altijd in Calf cream uitgevoerd.',
    tongue_label_note: 'Altijd op binnenzool',
    polster_tongue_note: 'Altijd op 3mm',
  },
  leg_cover: {
    liner_note: 'De voering wordt altijd in Rosschevreaux uitgevoerd.',
    supplement_note: 'Het supplement wordt altijd in type A uitgevoerd',
  },
  liner_shoe: {
    lining_note: 'De sluiting wordt altijd met haken uitgevoerd.',
    heel_note: 'De hak zit altijd in het onderwerk.',
    sole_note: 'De zool wordt altijd uitgevoerd in EVA 6 mm.',
    explanation_text: 'Met het invullen van de opties in Voeringschoen Proeffase krijgt u een Voeringschoen met een voorziening, een EVA Zool, een EVA Hak en haken.',
  },
  bath_shoe: {
    fastening_note: 'De sluiting wordt altijd met klittenband met passant uitgevoerd.',
    heel_type_note: 'De hak wordt altijd als Sleehak uitgevoerd.',
    sole_note: 'De zool wordt altijd uitgevoerd in EVA 6 mm.',
  },
  slipper: {
    liner_note: 'De voering wordt altijd bijpassend in Sanino uitgevoerd.',
    heel_type_note: 'De hak wordt altijd als Sleehak uitgevoerd.',
    sole_note: 'De zool wordt altijd uitgevoerd in EVA 6 mm.',
  },
  order: {
    shafts: 'Schachten',
    existing_model: 'Model als gehad',
    select_image: 'Kies een afbeelding',
    remove_shoe_image: 'Verwijder schoen afbeelding',
    color: 'Kleur',
    colors: 'Kleuren',
    models: 'Modellen',
    all: 'Alle',
    amount: 'Aantal',
    variant: 'Uitvoering',
    extra_layer_thickness: 'Extra laag dikte',
    leather_no: 'Leer {no}',
    leather_info: 'Leer is een natuurproduct en kan in structuur en kleur afwijken van foto en staal. Afwijkingen horen bij het gebruik van leer.',
    decoration: 'Decoratie',
    perforation: 'Perforatie',
    complexity_price: 'Duidelijke afbeelding in kleur leveren',
    embroidery: 'Borduurwerk',
    lasering: 'Laseren',
    lining: 'Voering',
    sensitive_skin: 'Gevoelige huid',
    vamp_lining: 'Voorblad voering',
    offset: 'Afstand',
    heelpart_lining: 'Achtervoering',
    tongue_reinforcement_add: 'Tongversteviging toevoegen',
    tongue_reinforcement: 'Tongversteviging',
    tongue_label: 'Tonglabel',
    tongue_stiffener: 'Tongverstijving',
    lining_vamp: 'Voorbladvoering',
    sockshoe: 'Uitvoeren als sokschoen',
    sockshoe_description: 'Onderwerk uitgevoerd met Ercoflex binnenzool en ruwe overlederloopzool.',
    lining_vamp_no_stitches: 'Voorbladvoering naadloos',
    heel_panel_lining: 'Hielpand voering',
    antislip_heel: 'Anti-slip',
    liner_shoe: 'Voeringschoen inplakken',
    vamp_point: 'Inschotpunt',
    main_stitches: 'Hoofdstiksel',
    decoration_stitching: 'Sierstiksel',
    quarter_opening: 'Openstand',
    choose_quarter_opening: 'Kies openstand',
    stitching_yarn: 'Dikte',
    fastening: 'Sluiting {no}',
    upper_height: 'Hoogte schacht',
    shaft_height_incl_heel: 'Schachthoogte inclusief hakhoogte',
    leg_measurements: 'Beenmaten',
    tongue_padding: 'Tongpolstering',
    padded_shaft: 'Polster schacht',
    polster_foam: 'Polster / Foam',
    polster: 'Polstering',
    polster_upper: 'Hielpolster',
    polster_upper_left: 'Hielpolster links',
    polster_upper_right: 'Hielpolster rechts',
    polstering: 'Polster/foam',
    polstering_material: 'Materiaal polstering',
    polster_tongue: 'Polster tong',
    heelcollar_polster: 'Boordpolster',
    heelcollar_polster_type: 'Uitvoering boord',
    tongue: 'Tong',
    fixation_tongue: 'Tong bevestiging',
    supplement_type: 'Supplement type',
    supplement_stiffening: 'Verstijving',
    supplement_thickness: 'Supplement dikte',
    detailed_supplement_thickness: 'Supplement dikte (detaillering)',
    supplement_retaining_wall_height: 'Hoogte keerwand',
    supplement_amenity_height: 'Hoogte voorziening',
    detail_drawing: 'Werktekening',
    thickness_left: 'Dikte links',
    thickness_right: 'Dikte rechts',
    thickness_front: 'Dikte voorzijde',
    bottoming: 'Onderwerk',
    manufacture_method: 'Maakwijze',
    manufacture_method_note: 'Let op, snellere levertijd Type A, indien gefreesd!',
    manufacture_method_layer: 'Bovenste laag - tot aan de voetzool',
    supplement_remark: 'Opmerkingen Supplementen',
    fillsole: 'Ruimtezool / vulzool',
    innersole: 'Binnenzool',
    forefoot_prosthesis: 'Voorvoet prothese (teen amputatie)',
    sole_stiffner: 'Zoolverstijving',
    nose_material: 'Neus versteviging',
    sole_supply_separately: 'Zool los leveren',
    nose_length: 'Neus lengte',
    nose_reinforcement: 'Neusversteviging',
    counter_stiffening: 'Tegenverstijving',
    reinforcement_provision: 'Versteviging / voorziening',
    heel_stiffener: 'Versteviging',
    heel_stiffener_variant: 'Versteviging uitvoering',
    heel_stiffener_height: 'Versteviging hoogte',
    last_annotation: 'Zoals aangetekend op leest',
    garnish: 'Bezetsels',
    shaft_up_to_and_including_pins: 'Schacht tot en met oppennen',
    shaft_up_to_supply_material: 'Onderwerk materiaal los meeleveren',
    modeling_extension: 'Modelleringsverlenging',
    boarding: 'Stootband',
    boarding_front: 'Voorzijde',
    boarding_back: 'Achterzijde',
    boarding_front_back: 'Voor + achterzijde',
    welt: 'Rand',
    all_welts: 'Alle randen',
    prefab_bottoming: 'Prefab onderwerk',
    mid_sole: 'Tussenzool',
    no_foot_strike: 'let op: geen afwikkeling',
    polstering_note: 'Controleer de uitvoering van de boordpolster en de gewenste hoogte van uw TVO.',
    heel: 'Hak',
    heel_type: 'Haktype',
    heel_position: 'Hak positie',
    heel_position_supplement: 'Hoogte (mm) verwerken in supplement',
    heel_position_bottoming: 'Hoogte (mm) verwerken in onderwerk',
    heel_color: 'Hakkleur/materiaal',
    primary_color: 'Hoofdkleur/materiaal',
    secondary_color: 'Tweede kleur/materiaal',
    heel_shore: 'Shorewaarde',
    heel_height: 'Hakhoogte',
    heel_width: 'Hakfront breedte',
    copy_left: 'Kopieer van links',
    heel_rolling: 'Hak afronding',
    heel_buffer: 'Hakbuffering',
    heel_expansion: 'Hakverbreden/Onderschuren',
    medial: 'Mediaal',
    lateral: 'Lateraal',
    rolling: 'Afwikkeling',
    rolling_side: 'Afwikkeling {side}',
    rolling_type: 'Afwikkeling type',
    rolling_direction: 'Afwikkelrichting',
    rolling_width: 'Afwikkellijn breedte',
    thickness_toe: 'Teendikte',
    thickness_ball: 'Baldikte',
    thickness_ball_lateral: 'Baldikte lateraal',
    thickness_ball_medial: 'Baldikte mediaal',
    thickness_heel: 'Hieldikte',
    rocker_wrapped_in_boarding: 'Afwikkeling ingepakt in stootband',
    sole: 'Zool',
    toplift: 'Achterlap',
    finishing: 'Afwerken',
    cover: 'Dekje',
    cover_material: 'Materiaal dekje',
    polster_material: 'Polsterlaag materiaal',
    lasting: 'Uitleesten',
    executor: 'Uitvoeren door',
    laces: 'Veters',
    finish_supplement: 'Supplement afwerken',
    place_cover: 'Polsterlaag plaatsen',
    padding_layer: 'Polsterlaag',
    shaft_remark: 'Opmerkingen Schachten',
    bottoming_remark: 'Opmerkingen Onderwerk',
    remarks: 'Opmerkingen',
    info: 'Order informatie',
    salutation: 'Aanhef',
    attachments: 'Bijlagen',
    last_no: 'Leestnummer',
    last_note: 'Leestnummer op leestkam aangeven',
    customer_name: 'Klant naam',
    confirm_leave_header: 'Wijzigingen annuleren?',
    confirm_leave_message: 'Weet u zeker dat u de orderpagina wilt verlaten? Eventuele ingevoerde data wordt niet opgeslagen.',
    sent_toast: 'Order is verzonden',
    number: 'Order',
    date: 'Datum',
    draft: 'Offerte',
    sale: 'Verkooporder',
    sent: 'Offerte verstuurd',
    done: 'Geblokkeerd',
    cancel: 'Geannuleerd',
    reorder: 'Opnieuw bestellen',
    edit: 'Bewerken',
    form: 'Formulier',
    velcro_extra_length: 'Extra lengte Klittenband',
    last: 'Leest',
    supplement: 'Supplement',
    has_last: 'Heeft leest',
    supplements: 'Supplementen',
    foil_shoe: 'Folieschoenen',
    foil_shoe_height: 'Hoogte (incl. supplement)',
    foil_shoe_remark: 'Opmerkingen folieschoenen',
    copy_existing_last: 'Bestaande leest kopiëren',
    deliver: 'Aanleveren',
    deliver_note: 'Welke documentatie stuurt u op of voegt u toe?',
    cast: 'Cast',
    blueprint: 'Blauwdruk',
    lutracad: 'Lutracad',
    techmed: 'ZSM scan',
    modeled_file: 'Gemodeleerde file aanleveren',
    scan_upload: 'Scan (eigen bestand)',
    techmed_scan: 'ZSM scan aangeleverd',
    last_type: 'Type leest',
    last_same_length: 'Leest even lang',
    encore: 'Toegift',
    encore_division: 'Leestlengte {side}',
    leg_position: 'Beenstand',
    fabric_edge: 'Stofrand',
    nose_shape: 'Neusvorm',
    last_remark: 'Opmerkingen Leesten',
    sizing: 'Maatvoering',
    leg_sizes: 'Omvangsmaten benen',
    height_measurement: 'Hoogte meting',
    circumferences: 'Omvangsmaten voeten',
    circumferences_no: 'Omvangsmaten voet {no}',
    foot_measurements: 'Correcties aan het bodemprofiel',
    position_toes: 'Positie tenen',
    height_toes: 'Hoogte',
    depth_toes: 'Diepstand',
    mtp_joints: 'MTP gewrichten',
    depth_position: 'MTP {no}',
    lateral_and_medial_gel: 'Lateraal en Mediaal geleng',
    medial_gel: 'Mediaal geleng',
    lateral_gel: 'Lateraal geleng',
    imprint_base_back: 'Opdruk achter Basis V',
    forefoot_support: 'Voorvoetsteun',
    forefoot_support_instructions: 'Aftekenen op supplement',
    t_pad: 'T-pelotte',
    transversal: 'Transversaalsteun',
    forefoot_and_heel_bone: 'Pronatie en Supinatie',
    pronation_front: 'Pronatie voorvoet',
    pronation_back: 'Pronatie achtervoet',
    suppination_front: 'Supinatie voorvoet',
    suppination_back: 'Supinatie achtervoet',
    lasts_supplements_foils: 'Leesten, supplementen en folies',
    finish: 'Afwerken',
    classics: 'Classics',
    flea: 'Vlos',
    leg_cover_remark: 'Opmerkingen koker',
    orthotics: 'Orthesen',
    functional: 'Functioneel',
    heel_instep: 'Hiel / wreef',
    high_instep: 'Hoge wreef',
    low_instep: 'Lage wreef',
    ball: 'Bal',
    toe_jump: 'Teensprong',
    heel_lift: 'Hielheffing',
    heel_thickness: 'Dikte hiel',
    toe_no: 'Teen {no}',
    dimensions: 'Maatvoering',
    order_status: 'Orderstatus',
    confirm_osa_header: 'Maximale aantal OSA\'s in winkelwagen',
    confirm_osa_message: 'Wilt u de winkelwagen legen en een nieuwe bestelling starten?',
    confirm_osa_button_ok: 'Winkelwagen legen',
    paper_between_wedge_impact_and_sole: 'Papier tussen zwikinslag en zool',
    paper_between_wedge_impact_and_sole_explanation: 'Papieren scheidingslaag voor correcties: tussen het rand en de onderwerk constructie wordt een papieren scheidingslaag aangebracht. Deze maakt een eenvoudige scheiding van de onderdelen mogelijk zodat je eenvoudig een been beugel kan bevestigen.',
    leg_cover: 'Koker',
    trial_shoe: 'Proefschoen',
    bath_shoe: 'Badschoen',
    slipper: 'Pantoffel',
    basics: 'Basics',
    osb: 'Basics OSB en modulair',
    size_charts: 'Maattabellen',
    kind: 'Soort',
    thickness_no: 'Dikte {no}',
    changed_color_remark: '{color} is veranderd van kleur',
  },
  cart: {
    title: 'Winkelwagen',
    order: 'U bestelt voor',
    empty: 'Je winkelwagen is leeg',
    added_header: 'Product toegevoegd',
    added_subHeader: 'voor {customer}',
    added_text: 'Wilt u nog een product toevoegen voor deze klant?',
    added_continue_shopping: 'Extra product toevoegen',
    add_product: 'Product toevoegen',
    added_finish_order: 'Naar Winkelwagen',
    last_supplement_or_foil: 'Leest, supplement of folie',
    finish: 'Afwerken',
    custom: 'Custom',
    send_header: 'Bestelling versturen?',
    send_text: 'Let op: controleer goed of de order correct is ingevuld.',
    send_ok: 'Ja, versturen',
    submitting_order: 'Bezig met verwerken order',
    submitting_line: 'Verwerken van regel {index} van {total}',
    submitting_attachment: 'Verwerken van bijlage {index} van {total}',
    new_order: 'Nieuwe order plaatsen',
    confirm_empty_header: 'Weet u zeker dat u de klantgegevens en winkelwagen wilt legen?',
    confirm_empty_button_ok: 'Opnieuw beginnen',
    edit_client_info: 'Wijzigen',
    production_order: 'Versleep de producten om de productievolgorde aan te passen.\nDe order wordt van boven naar onder verwerkt.',
    verify_order: 'Check all order lines via the cogwheel icon.',
    verify_order_label: 'Orderregel verificatie',
  },
};
